/* ASELECION – persoenlicher Gruss von Nino oben im Hero.
   Eigene Datei, damit der grosse Abschnitt unveraendert bleibt. */
(function () {
  var CSS =
    '.asel-note{display:flex;align-items:center;gap:14px;max-width:30rem;margin:0 0 30px;padding:10px 20px 10px 10px;' +
    'border-radius:999px;background:#FFFDF9;border:1px solid var(--line);box-shadow:0 14px 30px -26px rgba(0,0,0,.4);' +
    'opacity:0;transform:translateY(28px);animation:asel-note-in 1s cubic-bezier(.2,.7,.2,1) .15s forwards}' +
    '.asel-note .av{flex:none;width:56px;height:56px;border-radius:50%;overflow:hidden;background:var(--sage)}' +
    '.asel-note .av img{width:100%;height:100%;object-fit:cover;transform:scale(2.5);transform-origin:45% 31%}' +
    '.asel-note p{margin:0;font-size:14.5px;line-height:1.45;color:var(--muted)}' +
    '.asel-note b{display:block;font-weight:400;font-family:var(--display);font-style:italic;font-size:18px;color:var(--ink)}' +
    '@keyframes asel-note-in{to{opacity:1;transform:none}}' +
    '@media (max-width:860px){.asel-note{margin-bottom:22px;padding:8px 16px 8px 8px;gap:11px}' +
    '.asel-note .av{width:46px;height:46px}.asel-note p{font-size:13px}.asel-note b{font-size:16px}}' +
    '@media (prefers-reduced-motion:reduce){.asel-note{opacity:1;transform:none;animation:none}}';

  function init() {
    var col = document.querySelector('.hero .wrap > div');
    var src = document.querySelector('.founder .img img');
    if (!col || !src || document.querySelector('.asel-note')) return;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var note = document.createElement('div');
    note.className = 'asel-note';
    note.innerHTML =
      '<span class="av"><img src="' + src.getAttribute('src') +
      '" alt="Nino, Gründer von ASELECION" width="300" height="300"></span>' +
      '<p><b>Hi, ich bin Nino.</b>Ich baue ASELECION gerade auf – und du kannst von Tag eins dabei sein.</p>';
    col.insertBefore(note, col.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
